import React from 'react'
import styled from 'styled-components'

import Title from './Title'
import { CLIENT_STYLINGS } from '../../../utils/constants'

export const StyledTitle = styled(({ ...rest }) => <Title {...rest} />)`
  display: 'inline-flex';
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MAIN_COLOR};
  font-size: 1.8rem;
  line-height: 2rem;
  margin: 20px 0px 0px;
`
